import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-edit-reason-modal',
    templateUrl: './edit-reason-modal.component.html',
    styleUrls: ['./edit-reason-modal.component.scss'],
    standalone: false
})
export class EditReasonModalComponent {
  @Input() title: string = 'Edit History';
  @Input() fullReason: string = '';

  faInfoCircle = faInfoCircle;

  constructor(public readonly activeModal: NgbActiveModal) {}

  get reasonLines(): string[] {
    return (this.fullReason || '').split('\n').filter(line => line.trim().length > 0);
  }
}
